import { Theme } from "../app/enums/theme";
import { baseConfig } from "./environment.base";
// Base Config for All RRD Configs
baseConfig.theme = Theme.Rrd;

export const rrdBaseConfig = baseConfig;
